import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppBottomSheet } from "./Generic/AppBottomSheet";
import { AppButton } from "./Generic/AppButton";

export default function PatientsFilterBottomSheet(props: {
  isOpen: boolean;
  availablePatientSchedule: string[];
  availableBoroughs: string[];
  availableVisitTypes: string[];
  patientSchedule: string[];
  boroughs: string[];
  visitTypes: string[];
  onChangePatientSchedule: (schedule: string[]) => void;
  onChangeBoroughs: (boroughs: string[]) => void;
  onChangeVisitTypes: (visitTypes: string[]) => void;
  onRequestClose: () => void;
}) {
  return (
    <AppBottomSheet
      rounded
      isOpen={props.isOpen}
      title={translate(STRINGS.FILTERS)}
      restrictHeight={false}
      onRequestClose={props.onRequestClose}
    >
      <Form>
        {props.availablePatientSchedule.length > 0 && (
          <FormGroup>
            <Label>{translate(STRINGS.PATIENT_SCHEDULE)}</Label>
            <TagGroup
              items={props.availablePatientSchedule}
              selectedItems={props.patientSchedule}
              onClick={(schedule) =>
                props.onChangePatientSchedule(toggleMany(props.patientSchedule, schedule))
              }
            />
          </FormGroup>
        )}
        {props.availableBoroughs.length > 0 && (
          <FormGroup>
            <Label>{translate(STRINGS.BOROUGH)}</Label>
            <TagGroup
              items={props.availableBoroughs}
              selectedItems={props.boroughs}
              onClick={(borough) => props.onChangeBoroughs(toggleMany(props.boroughs, borough))}
            />
          </FormGroup>
        )}
        {props.availableVisitTypes.length > 0 && (
          <FormGroup>
            <Label>{translate(STRINGS.VISIT_TYPE)}</Label>
            <TagGroup
              items={props.availableVisitTypes}
              selectedItems={props.visitTypes}
              onClick={(visitType) =>
                props.onChangeVisitTypes(toggleMany(props.visitTypes, visitType))
              }
            />
          </FormGroup>
        )}

        <Spacer />

        <AppButton variant="filled" block onClick={props.onRequestClose}>
          {translate(STRINGS.DONE)}
        </AppButton>
      </Form>
    </AppBottomSheet>
  );
}

function TagGroup<T extends string>(props: {
  items: T[];
  selectedItems: T[];
  onClick: (item: T) => void;
}) {
  return (
    <Wrap>
      {props.items.map((item) => (
        <Tag
          key={item}
          variant={props.selectedItems.includes(item) ? "filled" : "outline"}
          size="small"
          onClick={() => props.onClick(item)}
        >
          {item}
        </Tag>
      ))}
    </Wrap>
  );
}

const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
`;

const Tag = styled(AppButton)`
  font-weight: 600 !important;
  margin: 0 !important;
  border: 2px solid transparent;
`;

const Wrap = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const Spacer = styled.div``;

function toggleMany<T>(list: T[], item: T) {
  return list.includes(item) ? list.filter((i) => i !== item) : [...list, item];
}
